<div class="row">
  <div class="col-lg-12 col-sm-12 col-md-12 header-center">
    <table>
      <tr>
        <td>
          <img src="assets/images/PanadolLogo1x.png" class="header-logo" />
        </td>
        <td class="header-title">
          Paracetamol recommended in<strong> national and international
            clinical practice guidelines*</strong> for common pain conditions
        </td>
      </tr>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="table-container" style="width:100%;visibility: hidden;">
      <table style="width:100%;table-layout:fixed">
        <tr>
          <td style="width: 110px;vertical-align: top;position: relative;left: 4px;">
            <div class="row scrollable" style="display: flex;">
              <div class="left-header">
                <div class="bg-blue row-1">Level of<br /> recommendation*</div>
                <div class="bg-blue row-2">1<sup>st</sup> level</div>
                <div class="bg-blue row-3">Recommended</div>
                <div class="bg-blue row-4">2<sup>nd</sup> level</div>
              </div>
            </div>
          </td>
          <td style="vertical-align:top;">
            <!-- scrollable right side content -->
            <div class="right-side" style="width:100%;">
              <div class="top-header" style="table-layout:fixed;width:100%">
                <div class="row scrollable" style="display: flex">

                  <div id="parent-div-2" class="column">
                    <div class="row-1">Tension-type <br />headache</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Europe<sup>1</sup><br />
                        Italy<sup>2</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Canada<sup>3</sup><br />
                        Croatia<sup>4</sup><br />
                        Denmark<sup>5</sup><br />
                        Nigeria<sup>6</sup><br />
                        UK<sup>7,8,9</sup><br />
                        USA<sup>10</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>
                        Germany,<br />
                        Austria,<br />
                        Switzerland<sup>11</sup>
                      </div>
                    </div>
                  </div>

                  <div id="parent-div-3" class="column">
                    <div class="row-1">Migraine</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Canada<sup>3</sup><br />
                        Denmark<sup>7</sup><br />
                        Ethiopia<sup>12</sup><br />
                        Europe<sup>13</sup><br />
                        France<sup>14</sup><br />
                        Germany, Austria,<br />
                        Switzerland<sup>11</sup><br />
                        Ireland<sup>15</sup><br />
                        South Africa<sup>16</sup><br />
                        USA<sup>17</sup><br />
                        Zimbabwe<sup>18</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Brazil<sup>19</sup><br />
                        Canada<sup>20,21</sup><br />
                        UK<sup>22</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>
                        Croatia<sup>23</sup><br />
                        Ghana<sup>24</sup><br />
                        UK<sup>25</sup>
                      </div>
                    </div>
                  </div>

                  <div id="parent-div-4" class="column">
                    <div class="row-1">Dysmenorrhea</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Afghanistan<sup>26</sup><br />
                        Ghana<sup>27</sup><br />
                        Kenya<sup>28</sup><br />
                        South Africa<sup>29</sup><br />
                        UK<sup>30</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Canada<sup>31,32</sup><br />
                        USA<sup>33</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>UK<sup>30</sup></div>
                    </div>
                  </div>

                  <div id="parent-div-5" class="column">
                    <div class="row-1">General pain</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Canada<sup>34</sup><br />
                        Rwanda<sup>35</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>USA<sup>36</sup></div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                    </div>
                  </div>

                  <div id="parent-div-6" class="column">
                    <div class="row-1">Acute back pain</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Australia<sup>37</sup><br />
                        Canada<sup>38,39</sup><br />
                        Europe<sup>40,41</sup><br />
                        Italy<sup>42</sup><br />
                        Malaysia<sup>43</sup><br />
                        New Zealand<sup>44,45</sup><br />
                        Norway<sup>46</sup><br />
                        Philippines<sup>47</sup><br />
                        UK<sup>48, 49</sup><br />
                        USA<sup>50, 51</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Canada<sup>52</sup><br />
                        USA<sup>53</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>
                        Italy<sup>54</sup><br />
                        Malaysia<sup>55</sup>
                      </div>
                    </div>
                  </div>

                  <div id="parent-div-7" class="column">
                    <div class="row-1">Osteoarthritis</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Afghanistan<sup>56</sup><br />
                        Canada<sup>57,58</sup><br />
                        China<sup>59</sup><br />
                        Ethiopia<sup>60</sup><br />
                        Europe<sup>61</sup><br />
                        India<sup>62</sup><br />
                        Malaysia<sup>63</sup><br />
                        New Zealand<sup>64</sup><br />
                        Philippines<sup>65</sup><br />
                        Russia<sup>66</sup><br />
                        South Africa<sup>67</sup><br />
                        Sri Lanka<sup>68</sup><br />
                        UK<sup>69</sup><br />
                        USA<sup>70</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Australia<sup>71,72</sup><br />
                        Nigeria<sup>73</sup><br />
                        USA<sup>74-77</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>Europe<sup>78</sup></div>
                    </div>
                  </div>

                  <div id="parent-div-8" class="column">
                    <div class="row-1">Dental pain</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Australasia<sup>79</sup><br />
                        Canada<sup>80</sup><br />
                        France<sup>81</sup><br />
                        UK<sup>82</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Malaysia<sup>83</sup><br />
                        Sweden<sup>84</sup><br />
                        UK<sup>82, 85</sup><br />
                        USA<sup>86-90</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>
                        Canada<sup>80</sup>
                      </div>
                    </div>
                  </div>

                  <div id="parent-div-9" class="column">
                    <div class="row-1">Postoperative pain</div>
                    <div class="bg-green table-text-color row-2">
                      <div>
                        Australasia<sup>91</sup><br />
                        Italy<sup>92</sup><br />
                        South Africa<sup>93</sup><br />
                        USA<sup>94,95</sup>
                      </div>
                    </div>
                    <div class="row-3 bg-grey table-text-color">
                      <div>
                        Europe<sup>96,97</sup><br />
                        France<sup>98</sup><br />
                        Korea<sup>99</sup><br />
                        Malaysia<sup>100</sup><br />
                        Poland<sup>101</sup><br />
                        Rwanda<sup>35</sup><br />
                        Sri Lanka<sup>102</sup><br />
                        USA95,<sup>103</sup><br />
                        Zimbabwe<sup>18</sup>
                      </div>
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <div>
                        Australasia<sup>79</sup><br />
                        Europe<sup>104</sup><br />
                        Italy<sup>92</sup>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<!-- <div class="row">
  <div class="col-lg-12">
    <div style="width:100%;margin-top:15px;">
      <table style="width:100%;table-layout:fixed">
        <tr>
          <td style="width: 110px;vertical-align: top;">
            <table class="left-header">
              <tr>
                <td class="bg-blue">
                  Level of
                  recommendation*
                </td>
              </tr>
              <tr>
                <td class="bg-blue" style="height:190px;">1<sup>st</sup> level</td>
              </tr>
              <tr>
                <td class="bg-blue" style="height:125px;">Recommended</td>
              </tr>
              <tr>
                <td class="bg-blue" style="height:50px;">2<sup>nd</sup> level</td>
              </tr>


            </table>
          </td>
          <td style="vertical-align:top">
            <div class="right-side" style="width:100%;overflow-x: scroll;">
              <table class="top-header" style="table-layout:fixed;width:1100px">
                <tr>
                  <td style="width:110px;">
                    Tension-type <br/>
                    headache
                  </td>
                  <td>Migraine</td>
                  <td>Dysmenorrhea</td>
                  <td>General pain</td>
                  <td>
                    Acute back pain
                  </td>
                  <td>
                    Osteoarthritis
                  </td>
                  <td>
                    Dental pain
                  </td>
                  <td>
                    Postoperative pain
                  </td>



                </tr>
                <tr>
                  <td style="text-align:center;height:190px;vertical-align: middle;" class="bg-green table-text-color">
                    Europe<sup>1</sup><br />
                    Italy<sup>2</sup>
                  </td>
                  <td style="text-align:center; vertical-align: middle;" class="bg-green table-text-color">
                    Canada<sup>3</sup><br />
                    Denmark<sup>7</sup><br />
                    Ethiopia<sup>12</sup><br />
                    Europe<sup>13</sup><br />
                    France<sup>14</sup><br />
                    Germany, Austria,<br />
                    Switzerland<sup>11</sup><br />
                    Ireland<sup>15</sup><br />
                    South Africa<sup>16</sup><br />
                    USA<sup>17</sup><br />
                    Zimbabwe<sup>18</sup>
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-green table-text-color">
                    Afghanistan<sup>26</sup><br />
                    Ghana<sup>27</sup><br />
                    Kenya<sup>28</sup><br />
                    South Africa<sup>29</sup><br />
                    UK<sup>30</sup>

                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-green table-text-color">
                    Canada<sup>34</sup><br />
                    Rwanda<sup>35</sup>
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-green table-text-color">
                    Australia<sup>37</sup><br />
                    Canada<sup>38,39</sup><br />
                    Europe<sup>40,41</sup><br />
                    Italy<sup>42</sup><br />
                    Malaysia<sup>43</sup><br />
                    New Zealand<sup>44,45</sup><br />
                    Norway<sup>46</sup><br />
                    Philippines<sup>47</sup><br />
                    UK<sup>48, 49</sup><br />
                    USA<sup>50, 51</sup>


                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-green table-text-color">
                    Afghanistan<sup>56</sup><br />
                    Canada<sup>57,58</sup><br />
                    China<sup>59</sup><br />
                    Ethiopia<sup>60</sup><br />
                    Europe<sup>61</sup><br />
                    India<sup>62</sup><br />
                    Malaysia<sup>63</sup><br />
                    New Zealand<sup>64</sup><br />
                    Philippines<sup>65</sup><br />
                    Russia<sup>66</sup><br />
                    South Africa<sup>67</sup><br />
                    Sri Lanka<sup>68</sup><br />
                    UK<sup>69</sup><br />
                    USA<sup>70</sup>

                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-green table-text-color">
                    Australasia<sup>79</sup><br />
                    Canada<sup>80</sup><br />
                    France<sup>81</sup><br />
                    UK<sup>82</sup>


                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-green table-text-color">
                    Australasia<sup>91</sup><br />
                    Italy<sup>92</sup><br />
                    South Africa<sup>93</sup><br />
                    USA<sup>94,95</sup>


                  </td>



                </tr>
                <tr>
                  <td style="text-align:center;height:125px;vertical-align: middle;" class="bg-grey table-text-color">
                    Canada<sup>3</sup><br />
                    Croatia<sup>4</sup><br />
                    Denmark<sup>5</sup><br />
                    Nigeria<sup>6</sup><br />
                    UK<sup>7,8,9</sup><br />
                    USA<sup>10</sup>


                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-grey table-text-color">
                    Brazil<sup>19</sup><br />
                    Canada<sup>20,21</sup><br />
                    UK<sup>22</sup>



                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-grey table-text-color">
                    Canada<sup>31,32</sup><br />
                    USA<sup>33</sup>



                  </td>

                  <td style="text-align:center;vertical-align: middle;" class="table-text-color">

                    USA<sup>36</sup>


                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="table-text-color">

                    Canada<sup>52</sup><br />
                    USA<sup>53</sup>



                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="table-text-color">

                    Australia<sup>71,72</sup><br />
                    Nigeria<sup>73</sup><br />
                    USA<sup>74-77</sup>


                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="table-text-color">

                    Malaysia<sup>83</sup><br />
                    Sweden<sup>84</sup><br />
                    UK<sup>82, 85</sup><br />
                    USA<sup>86-90</sup>



                  </td>

                  <td style="text-align:center;vertical-align: middle;" class="table-text-color">

                    Europe<sup>96,97</sup><br />
                    France<sup>98</sup><br />
                    Korea<sup>99</sup><br />
                    Malaysia<sup>100</sup><br />
                    Poland<sup>101</sup><br />
                    Rwanda<sup>35</sup><br />
                    Sri Lanka<sup>102</sup><br />
                    USA95,<sup>103</sup><br />
                    Zimbabwe<sup>18</sup>


                  </td>


                </tr>
                <tr>
                  <td style="text-align:center;height:50px;vertical-align: middle;"  class="bg-yellow table-text-color">

                    Germany,<br />
                    Austria,<br />
                    Switzerland<sup>11</sup>
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-yellow table-text-color">
                    Croatia<sup>23</sup><br />
                    Ghana<sup>24</sup><br />
                    UK<sup>25</sup>
                  </td>

                  <td style="text-align:center;vertical-align: middle;" class="bg-yellow table-text-color">
                    UK<sup>30</sup>
                  </td>
                  <td class="bg-yellow">
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-yellow table-text-color">
                    Italy<sup>54</sup><br />
                    Malaysia<sup>55</sup>
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-yellow table-text-color">
                    Europe<sup>78</sup>
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-yellow table-text-color">
                    Canada<sup>80</sup>
                  </td>
                  <td style="text-align:center;vertical-align: middle;" class="bg-yellow table-text-color">
                    Australasia<sup>79</sup><br />
                    Europe<sup>104</sup><br />
                    Italy<sup>92</sup>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div> -->

<div class="row" style="margin-top:10px;">
  <div class="col-12" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    *Hagen et al. performed a nonsystematic search of several databases (PubMed, ProQuest and Embase) for national and
    international guidelines (using terms such as ‘treatment’, ‘guidelines/guidance’, ‘consensus’,
    ‘recommendations/recommend’, ‘best practices’ and ‘quality standards’) (English language only) for common pain
    conditions (i.e., general pain, acute back pain, osteoarthritis, dysmenorrhea, dental pain, TTH, migraine and
    postoperative pain). They also searched websites of pain associations, societies, health institutions and
    organizations, and conducted open searches on Google and Google Scholar. The search included all guidelines until
    April 2019
    (no specific start date), but only the most updated guideline from any given group was included.<br /><br />
    The authors identified 114 relevant guidelines in adults, as well as four guidelines specifically written for pain
    in pregnancy, 11 guidelines that address pain in childhood and five guidelines developed for pain in older people.
    In the clinical guidelines identified different grading systems were often used to evaluate the quality of the
    evidence, and drugs were classified in several different ways, for example, using a grade or evel, and/or whether
    they were first or
    second line and choice. Many did not provide a level of recommendation, but simply recommended a class of drugs
    based mainly on clinical experience and the reported efficacy and safety. Although this summary may be a useful
    tool,
    decision makers must also take a closer look at the guidelines specific to their field of expertise.
  </div>
</div>

<div class="row" style="margin-top:50px;">
  <div class="col-lg-9" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    1<sup style="line-height: 0px;">st</sup> level 1 = grade A, level I, or first choice; 2<sup
      style="line-height: 0px;">nd</sup> level = grade B, level II, or second choice.<br />
    *Ref.: Adapted from Hagen M, Alchin J. Nonprescription drugs recommended in guidelines for common pain conditions.
    Pain Manag. 2020 Mar;10(2):117-129.
  </div>
  <div class="col-lg-3">
    <div style="float: right;">
      <div class="legend-icon bg-green" (click)="active = 1" (mouseover)="active = 1" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 1">
          <img class="popup-guidelines-green" />
        </div>
      </div>
      <div class="legend-icon bg-grey" (click)="active = 2" (mouseover)="active = 2" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 2">
          <img class="popup-guidelines-yellow" />
        </div>
      </div>
      <!--<div class="legend-icon bg-pink" (click)="active = 3" (mouseover)="active = 3" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 3">
          <img class="popup-panadol-pink" />
        </div>
      </div>-->
      <div class="legend-icon bg-yellow" (click)="active = 4" (mouseover)="active = 4" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 4">
          <img class="popup-guidelines-grey" />
        </div>
      </div>
    </div>

  </div>
</div>
